var InlineCookieInput = function(name,selector,callback,args){
    this.name = name;
    this.wrapper = jQuery(selector)[ 0 ]; // Get native DOM element but using jQuery for selecting
    this.button = null;
    this.input = null;
    this.value = this.getCookie();
    this.callback = callback;
    this.default_args = {
        empty_label: "Indtast",
        edit_label: "Ret",
        input_name: "ici_"+this.name,
    };
    this.args = {...this.default_args, ...args};

    this.hidden_class = "hidden";
    this.fullwidth_class = "full-width";

    // this.init();
};
// Initializes the input
InlineCookieInput.prototype.init = function () {
    this.wrapper.classList.add("inline_cookie_input");
    this.addElements();
    this.addEvents();
    this.updated("init");
};
// Adds input and button elements to wrapper
InlineCookieInput.prototype.addElements = function(){
    this.button = document.createElement("label");
    this.button.setAttribute("for",this.args.input_name);
    this.updateButtonLabel();

    this.input = document.createElement("input");
    this.setInputValue();
    this.input.classList.add(this.hidden_class);
    this.input.setAttribute("id",this.args.input_name);

    this.wrapper.append(this.button);
    this.wrapper.append(this.input);
};
// Add all events!! ! : D
InlineCookieInput.prototype.addEvents = function(){
    let that = this;
    this.button.addEventListener("click",() => {that.activateInput.call(that)});
    this.input.addEventListener("focusout", () => {that.deactivateInput.call(that)});
    this.input.addEventListener("change", () => {that.inputChange.call(that)});
};

// Set the inputs cookie to value
InlineCookieInput.prototype.setCookie = function(value){
    if(typeof value === "undefined" || value == ""){
        this.removeCookie();
    }else{
        document.cookie = this.name+"="+value+"; path=/";
    }
};
// Removes the inputs cookie to value
InlineCookieInput.prototype.removeCookie = function(){
    document.cookie = this.name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
};
// Returns the value of this inputs cookie
InlineCookieInput.prototype.getCookie = function(){
    return this.getCookies()[this.name];
};
// Return object of all cookies
InlineCookieInput.prototype.getCookies = function(){
    let cookies = {};
    document.cookie.split(";").forEach(function(cookie){
        let arr = cookie.trim().split("=");
        cookies[arr[0]] = arr[1];
    });
    return cookies;
};

// Whenever something updated fire the callback
InlineCookieInput.prototype.updated = function(eventname){
    if(typeof eventname === "undefined"){
        eventname = "unknown";
    }
    if(typeof this.callback === "function"){
        this.callback(this,eventname);
    }else if(typeof this.callback === "object" && typeof this.callback[0] === "function"){
        this.callback[0].call(this.callback[1],this,eventname);
    }
};

// Updates the buttons label
InlineCookieInput.prototype.updateButtonLabel = function(){
    if(typeof this.value === "undefined"){
        this.button.innerText = this.args.empty_label;
    }else{
        this.button.innerText = this.args.edit_label;
    }
};

InlineCookieInput.prototype.showInput = function () {
    this.input.classList.remove(this.hidden_class);
    this.wrapper.classList.add(this.fullwidth_class);
};
InlineCookieInput.prototype.showButton = function () {
    this.button.classList.remove(this.hidden_class);
};
InlineCookieInput.prototype.hideInput = function () {
    this.input.classList.add(this.hidden_class);
    this.wrapper.classList.remove(this.fullwidth_class);
};
InlineCookieInput.prototype.hideButton = function () {
    this.button.classList.add(this.hidden_class);
};
InlineCookieInput.prototype.activateInput = function(){
    this.showInput();
    this.hideButton();
};
InlineCookieInput.prototype.deactivateInput = function(){
    this.showButton();
    this.hideInput();
};
// Validates the input value
InlineCookieInput.prototype.validate = function( value ){
    if(typeof this.args.validation_function === "function"){
        return this.args.validation_function(value);
    }
    return typeof value !== "undefined";
};
// Callback for change event on input
// Updates cookie, this, and fires the callback
InlineCookieInput.prototype.inputChange = function(){
    let new_value = this.input.value;
    if(this.validate(new_value)){
        this.setCookie(new_value);
        this.value = this.getCookie();
        this.setInputValue();
        this.updated(this,"inputChange");
        this.updateButtonLabel();
        return true;
    }else{
        alert(this.args.validation_failed);
        this.setInputValue(this.value);
        this.updateButtonLabel();
        return false;
    }
};
// Sets the value in the input. If value is not defined then this.value is used
InlineCookieInput.prototype.setInputValue = function (value) {
    if (typeof value === "undefined"){
        value = (typeof this.value !== "undefined") ? this.value : "";
    }
    this.input.value = value;
};

export {InlineCookieInput};
